module.exports = __webpack_public_path__ + "media/images/area/feature/chubu/related/th/4-cee8ec48979ed290546ab7d3eea7aec1.jpg";